// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3UMMq","productName":"Table_productName__1vQ27"};